import { Button, Modal } from "antd";
import React from "react";
import PageDelete from "./PageDelete";

// Define the props type
interface PageDeleteModalProps {
  deleteModalOpen: boolean;
  handleDeleteClose: () => void;
  deleteLoading: boolean;
  onDelete: () => void;
  deleteName: string;
  actionDelete: string;
  deletePageLoading: boolean;
}

const PageDeleteModal: React.FC<PageDeleteModalProps> = (props) => {
  const {
    deleteModalOpen,
    handleDeleteClose,
    deleteLoading,
    onDelete,
    deleteName,
    actionDelete,
    deletePageLoading,
  } = props;

  return (
    <>
      <Modal
        width={500}
        open={deleteModalOpen}
        onCancel={handleDeleteClose}
        data-custom-delete-modal="custom-delete-modal-header"
        title={
          actionDelete === "delete_page"
            ? "Delete Page"
            : "Delete Page Component"
        }
        footer={
          <>
            <Button onClick={handleDeleteClose}>Cancel</Button>
            <Button
              htmlType="submit"
              onClick={onDelete}
              loading={deleteLoading || deletePageLoading}
            >
              Delete
            </Button>
          </>
        }
      >
        <PageDelete deleteName={deleteName}  />
      </Modal>
    </>
  );
};

export default PageDeleteModal;
